export default __webpack_public_path__ + "static/media/landscape.beb2f2ab.png";